/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1TransactionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_TRANSACTION_STATE_ENTITY_NAME = 'ixf.accounting.v1.Transaction';
export const ixfAccountingV1TransactionStateEntity = new schema.Entity<IxfAccountingV1TransactionState>(IXF_ACCOUNTING_V1_TRANSACTION_STATE_ENTITY_NAME, {}, { idAttribute: 'transactionId' });

